import { render, staticRenderFns } from "./paymentItemNew.vue?vue&type=template&id=5abccd26&"
import script from "./paymentItemNew.vue?vue&type=script&lang=js&"
export * from "./paymentItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports